var MSANTracker;
(function (MSANTracker) {
    var getGlobalWindow = (function () {
        function getGlobalWindow() {
        }
        getGlobalWindow.getGlobal = function () {
            if (typeof globalThis !== "undefined" && globalThis) {
                return globalThis;
            }
            if (typeof self !== "undefined" && self) {
                return self;
            }
            if (typeof window !== "undefined" && window) {
                return window;
            }
            return null;
        };
        getGlobalWindow.hasWindow = function () {
            return Boolean(typeof window === "object" && window);
        };
        getGlobalWindow.getGlobalInst = function (name) {
            if (name === "window" && this.hasWindow()) {
                return window;
            }
            var gbl = this.getGlobal();
            if (gbl && gbl[name]) {
                return gbl[name];
            }
            return null;
        };
        return getGlobalWindow;
    }());
    MSANTracker.getGlobalWindow = getGlobalWindow;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var Config = (function () {
        function Config() {
        }
        Config.trackerConfig = {
            useTelemetryService: false,
            selectorMethod: ".",
            directFunctionCall: true,
            impressionIdParamName: "",
            publisherName: "msnperegrine"
        };
        return Config;
    }());
    MSANTracker.Config = Config;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    ;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var VideoTrackEvents = (function () {
        function VideoTrackEvents() {
            this.element = null;
            this.trackBeacons = [];
        }
        return VideoTrackEvents;
    }());
    MSANTracker.VideoTrackEvents = VideoTrackEvents;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var Constants = (function () {
        function Constants() {
        }
        Constants.appinsights = {
            stagingConnectionString: "9b1500b8-3f89-4126-8af8-cd9020439a04",
            prodConnectionString: "922c1827-2168-46e4-b953-34fef5deff39"
        };
        Constants.msn = {
            videoViewIdMacro: "VIDEO_VIEW_ID"
        };
        return Constants;
    }());
    MSANTracker.Constants = Constants;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    MSANTracker._window = MSANTracker.getGlobalWindow.getGlobalInst("window");
    var utils = (function () {
        function utils() {
        }
        utils.isDebug = function (targetWindow) {
            return this.getQueryParam("na-debug", targetWindow.location.search) === "true";
        };
        utils.getRid = function (element) {
            if (MSANTracker.config.publisherName.indexOf("msn") >= 0) {
                for (var i = 0; i < element.beacons.length; i++) {
                    if (element.beacons[i].url.indexOf("https://srtb.msn.com") == 0) {
                        var rid = this.getQueryParam("rid", element.beacons[i].url);
                        return rid;
                    }
                }
            }
            return element.impid;
        };
        utils.replaceQueryParam = function (name, replacedValue, searchString) {
            var originValue = this.getQueryParam(name, searchString);
            var originString = name.concat("=").concat(originValue);
            var newString = name.concat("=").concat(replacedValue);
            if (searchString && searchString.indexOf(originString) >= 0) {
                return searchString.replace(originString, newString);
            }
            return searchString;
        };
        utils.getQueryParam = function (name, searchString) {
            var params = this.getQueryParams(new RegExp("^" + this.escapeRegExp(name) + "$"), searchString);
            return (params && params.length > 0) ? params[0].value : null;
        };
        utils.getQueryParams = function (nameRegex, searchString) {
            if (searchString && searchString.indexOf("?") >= 0) {
                searchString = searchString.substring(searchString.indexOf("?") + 1);
            }
            return this.getKeyValuePairs(nameRegex, searchString, "&");
        };
        utils.getKeyValuePairs = function (nameRegex, input, delimiter) {
            if (!input || !nameRegex || !nameRegex.test) {
                return [];
            }
            var matches = [];
            var pairs = input.split(delimiter);
            for (var i = 0; i < pairs.length; i++) {
                var pair = pairs[i];
                var equalIndex = pair.indexOf("=");
                if (equalIndex === -1) {
                    continue;
                }
                var name_1 = pair.substring(0, equalIndex).trim();
                var value = pair.substring(equalIndex + 1).trim();
                if (nameRegex.test(name_1)) {
                    matches.push({
                        name: name_1,
                        value: value
                    });
                }
            }
            return matches;
        };
        utils.escapeRegExp = function (str) {
            return str ? str.replace(this.regexSpecialCharsRegex, "\\$1") : str;
        };
        utils.consoleLog = function (str, targetWindow) {
            if (this.isDebug(targetWindow)) {
                console.log(str);
            }
        };
        utils.JSONstringify = function (obj) {
            if (typeof (JSON.stringify) === "function") {
                return JSON.stringify(obj);
            }
        };
        utils.getMetaContentByName = function (metaName, targetWindow) {
            try {
                if (!targetWindow) {
                    targetWindow = MSANTracker._window;
                }
                var metas = targetWindow.document.getElementsByTagName('meta');
                for (var i = 0; i < metas.length; i++) {
                    if (metas[i].getAttribute("name") === metaName) {
                        return metas[i].getAttribute("content");
                    }
                }
                return "";
            }
            catch (e) {
                return "";
            }
        };
        utils.loadScript = function (scriptSrc, callback) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptSrc;
            script.onload = callback;
            script.onreadystatechange = function () {
                if (this.readyState === 'complete') {
                    callback();
                }
            };
            head.appendChild(script);
        };
        utils.fireBeacon = function (beaconUrl) {
            if (beaconUrl) {
                if (MSANTracker._window && MSANTracker._window.Image) {
                    new MSANTracker._window.Image().src = beaconUrl;
                }
            }
        };
        utils.addQueryParam = function (url, name, value) {
            url += url.indexOf("?") == -1 ? "?" : "&";
            url += name + "=" + value;
            return url;
        };
        utils.isIE = function (targetWindow) {
            var userAgent = targetWindow.navigator.userAgent;
            return userAgent.indexOf("MSIE ") > -1;
        };
        utils.getCurrentScriptTag = function (targetWindow) {
            if (!targetWindow) {
                return null;
            }
            var currentScript = targetWindow.document.currentScript;
            if (currentScript && currentScript.src) {
                return currentScript.src;
            }
            var scripts = targetWindow.document.getElementsByTagName('script');
            if (scripts && scripts.length > 0) {
                var currentScript = scripts[scripts.length - 1];
                if (currentScript.src.indexOf("nativeads/msantracker") != -1) {
                    return currentScript.src;
                }
            }
            var currentScriptSrc = "";
            var queryToSearch = "script[src*='nativeads/msantracker']";
            var scriptTag = targetWindow.document.querySelector(queryToSearch);
            if (scriptTag) {
                currentScriptSrc = scriptTag.src;
            }
            return currentScriptSrc;
        };
        utils.isMSN = function (targetWindow) {
            if (!targetWindow) {
                return null;
            }
            return targetWindow.location.href.indexOf("msn.com") != -1;
        };
        utils.isStagingEnv = function (targetWindow) {
            if (!targetWindow) {
                return null;
            }
            var scriptSrc = this.getCurrentScriptTag(targetWindow);
            if (scriptSrc) {
                return scriptSrc.indexOf("nativeads/staging/") != -1;
            }
            return false;
        };
        utils.getPublisherName = function (scriptSrc) {
            if (!scriptSrc) {
                return "";
            }
            var publisher = this.getQueryParam("publisherName", scriptSrc);
            return publisher;
        };
        utils.inIframe = function () {
            try {
                return MSANTracker._window.self !== MSANTracker._window.top;
            }
            catch (e) {
                return true;
            }
        };
        utils.getTargetWindow = function () {
            if (this.inIframe()) {
                return MSANTracker._window.parent;
            }
            else {
                return MSANTracker._window;
            }
        };
        utils.isDocumentReady = function (targetWindow) {
            if (!targetWindow) {
                return false;
            }
            if (targetWindow.navigator.userAgent
                && targetWindow.navigator.userAgent.indexOf("Android") !== -1
                && targetWindow.document.readyState == "loaded") {
                return true;
            }
            if (targetWindow.document.readyState == "complete") {
                return true;
            }
            return false;
        };
        utils.getVideoViewId = function () {
            return this.getGuid().replace(/-/g, "");
        };
        utils.getGuid = function () {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) { var e = 16 * Math.random() | 0; return ("x" === t ? e : 3 & e | 8).toString(16); });
        };
        utils.regexSpecialCharsRegex = "/([.*+?^=!:${}()|\[\]\/\\])/g";
        return utils;
    }());
    MSANTracker.utils = utils;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var Telemetry = (function () {
        function Telemetry() {
        }
        Telemetry.initialize = function (targetWindow) {
            targetWindow = targetWindow;
        };
        Telemetry.logEvent = function (guid, eventName, eventProperties) {
            this.logEventForMSN(guid, eventName, eventProperties);
        };
        Telemetry.logEventForMSN = function (guid, eventName, eventProperties) {
            var samRTBLogUrl = "https://srtb.msn.com/log";
            if (eventName && eventProperties) {
                var rid = void 0;
                if (this.elementsToTrack && guid && this.elementsToTrack[guid]) {
                    rid = this.elementsToTrack[guid];
                }
                eventProperties["publishername"] = MSANTracker.config.publisherName;
                var eventDetails = this.targetWindow.btoa(MSANTracker.utils.JSONstringify(eventProperties)).substring(0, 1800);
                var url = samRTBLogUrl + "?r=" + rid + "&n=" + eventName + "&d=" + encodeURIComponent(eventDetails);
                MSANTracker.utils.fireBeacon(url);
                eventProperties.rid = rid;
                MSANTracker.utils.consoleLog("TelemetryEvent: " + eventName + " " + MSANTracker.utils.JSONstringify(eventProperties), this.targetWindow);
            }
        };
        Telemetry.setElementToTrack = function (guid, rid) {
            if (guid && rid) {
                this.elementsToTrack[guid] = rid;
            }
        };
        Telemetry.logAdView = function (guid, elementId, viewBeacon) {
            var eventProperties = {
                "elementId": elementId,
                "percentage": viewBeacon.percentage,
                "duration": viewBeacon.duration,
                "type": viewBeacon.type,
                "triggerType": viewBeacon.triggerType,
                "url": viewBeacon.url
            };
            this.logEvent(guid, "mt_view", eventProperties);
        };
        Telemetry.logVideoAdPlay = function (guid, elementId, videoBeacon) {
            var eventProperties = {
                "elementId": elementId,
                "percentage": videoBeacon.percentage,
                "duration": videoBeacon.duration,
                "type": videoBeacon.type,
                "triggerType": videoBeacon.triggerType,
                "url": videoBeacon.url
            };
            this.logEvent(guid, "mt_view", eventProperties);
        };
        Telemetry.logAdClick = function (guid, elementId, beacon) {
            var eventProperties = {
                "elementId": elementId,
                "type": beacon.type,
                "url": beacon.url
            };
            this.logEvent(guid, "mt_click", eventProperties);
        };
        Telemetry.targetWindow = MSANTracker._window;
        Telemetry.elementsToTrack = {};
        return Telemetry;
    }());
    MSANTracker.Telemetry = Telemetry;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var AppearUtils = (function () {
        function AppearUtils() {
        }
        AppearUtils.trackElement = function (selector, element, targetWindow, viewBeacon, callback) {
            var percentInView = AppearUtils.DEFAULT_PERCENTINVIEW;
            var milliSecondsInView = AppearUtils.DEFAULT_DURATIONINVIEW;
            if (viewBeacon) {
                if (viewBeacon.percentage) {
                    percentInView = viewBeacon.percentage;
                }
                if (viewBeacon.duration) {
                    milliSecondsInView = viewBeacon.duration;
                }
            }
            AppearUtils.elementsToTrack.push({
                selector: selector,
                element: element,
                targetWindow: targetWindow,
                percentInView: percentInView,
                milliSecondsInView: milliSecondsInView,
                viewBeacon: viewBeacon,
                action: callback
            });
            if (AppearUtils.processing == null) {
                AppearUtils.processing = setInterval(AppearUtils.process, AppearUtils.interval);
            }
            return this;
        };
        AppearUtils.process = function () {
            try {
                if (AppearUtils.elementsToTrack.length > 0) {
                    for (var i = 0; i < AppearUtils.elementsToTrack.length; i++) {
                        if (AppearUtils.appearedElements.indexOf(i) < 0 && AppearUtils.elementsWaitingForTimeout.indexOf(i) < 0 && AppearUtils.isElementInView(AppearUtils.elementsToTrack[i])) {
                            AppearUtils.elementsWaitingForTimeout.push(i);
                            setTimeout(AppearUtils.checkAfterTimeout, AppearUtils.elementsToTrack[i].milliSecondsInView, AppearUtils.elementsToTrack[i], i);
                        }
                    }
                    if (AppearUtils.elementsToTrack.length === AppearUtils.appearedElements.length) {
                        AppearUtils.stopProcessing();
                    }
                }
            }
            catch (e) {
                var eToTrack = AppearUtils.elementsToTrack;
                if (eToTrack.length > 0 && eToTrack[0] && eToTrack[0].viewBeacon) {
                    MSANTracker.Telemetry.logEvent(eToTrack[0].viewBeacon.guid, "mt_err", { msg: e.message, details: eToTrack[0].viewBeacon });
                }
                else {
                    MSANTracker.Telemetry.logEvent("", "mt_err", { msg: e.message });
                }
            }
        };
        AppearUtils.checkAfterTimeout = function (element, i) {
            if (AppearUtils.appearedElements.indexOf(i) < 0 && AppearUtils.isElementInView(element)) {
                AppearUtils.appearedElements.push(i);
                element.action.call(undefined, element.selector, element.viewBeacon, element.targetWindow);
            }
            AppearUtils.elementsWaitingForTimeout.splice(AppearUtils.elementsWaitingForTimeout.indexOf(i), 1);
        };
        AppearUtils.isElementInView = function (elementToTrack) {
            var targetWindow = elementToTrack.targetWindow;
            var document = targetWindow.document;
            if (!elementToTrack.element) {
                return false;
            }
            var element = elementToTrack.element;
            var bodyTag = document.getElementsByTagName('body');
            var body;
            if (bodyTag) {
                body = bodyTag[0];
            }
            var elementRect = element.getBoundingClientRect();
            if (!elementRect) {
                return false;
            }
            var elementRectLeft = elementRect.left === -1 ? 0 : elementRect.left;
            var elementRectTop = elementRect.top === -1 ? 0 : elementRect.top;
            var elementHeight = element.offsetHeight;
            var elementWidth = element.offsetWidth;
            var topElementInView = document.elementFromPoint(elementRectLeft + (elementWidth / 2), elementRectTop + (elementHeight / 2));
            var isTopFeedLayout = topElementInView && topElementInView.shadowRoot && topElementInView.shadowRoot.contains(element);
            var isTopVideoLayout = topElementInView && topElementInView.parentElement &&
                (topElementInView.parentElement.contains(element) || (topElementInView.parentElement.parentElement && topElementInView.parentElement.parentElement.contains(element)));
            if (!topElementInView || (topElementInView && element !== topElementInView && !element.contains(topElementInView) && !isTopFeedLayout && !isTopVideoLayout)) {
                return false;
            }
            var height = targetWindow.innerHeight || document.clientWidth || body.clientWidth;
            var width = targetWindow.innerWidth || document.clientHeight || body.clientHeight;
            var pageTop = targetWindow.pageYOffset;
            var pageBottom = pageTop + height;
            var elementTop = elementRectTop + targetWindow.scrollY;
            var elementBottom = elementTop + elementHeight;
            var pageLeft = targetWindow.pageXOffset;
            var pageRight = pageLeft + width;
            var elementLeft = elementRectLeft + targetWindow.scrollX;
            var elementRight = elementLeft + elementWidth;
            var metrics = { pTop: pageTop, pBottom: pageBottom, pLeft: pageLeft, pRight: pageRight,
                eTop: elementTop, eBottom: elementBottom, eLeft: elementLeft, eRight: elementRight,
                eWidth: elementWidth, eHeight: elementHeight, percentInView: elementToTrack.percentInView };
            return AppearUtils.validateIsElementInView(metrics);
        };
        AppearUtils.validateIsElementInView = function (metrics) {
            if (metrics.eBottom <= metrics.pTop || metrics.eTop >= metrics.pBottom
                || metrics.eRight <= metrics.pLeft || metrics.eLeft >= metrics.pRight) {
                return false;
            }
            var topOutside = 0;
            var rightOutside = 0;
            var bottomOutside = 0;
            var leftOutside = 0;
            if (metrics.pTop > metrics.eTop && metrics.pTop < metrics.eBottom) {
                topOutside = metrics.pTop - metrics.eTop;
            }
            if (metrics.pBottom < metrics.eBottom && metrics.pBottom > metrics.eTop) {
                bottomOutside = metrics.eBottom - metrics.pBottom;
            }
            if (metrics.pLeft > metrics.eLeft && metrics.pLeft < metrics.eRight) {
                leftOutside = metrics.pLeft - metrics.eLeft;
            }
            if (metrics.pRight < metrics.eRight && metrics.pRight > metrics.eLeft) {
                rightOutside = metrics.eRight - metrics.pRight;
            }
            var verticalOutside = topOutside + bottomOutside;
            var horizontalOutside = leftOutside + rightOutside;
            var outsideArea = (verticalOutside * metrics.eWidth) + (horizontalOutside * metrics.eHeight);
            var elementArea = metrics.eHeight * metrics.eWidth;
            if (outsideArea <= (elementArea * (100 - metrics.percentInView)) / 100) {
                return true;
            }
            else {
                return false;
            }
        };
        AppearUtils.stopProcessing = function () {
            clearInterval(AppearUtils.processing);
            AppearUtils.processing = null;
        };
        AppearUtils.DEFAULT_PERCENTINVIEW = 50;
        AppearUtils.DEFAULT_DURATIONINVIEW = 1000;
        AppearUtils.elementsToTrack = [];
        AppearUtils.appearedElements = [];
        AppearUtils.elementsWaitingForTimeout = [];
        AppearUtils.processing = null;
        AppearUtils.interval = 100;
        return AppearUtils;
    }());
    MSANTracker.AppearUtils = AppearUtils;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var PlayUtils = (function () {
        function PlayUtils() {
        }
        PlayUtils.trackElement = function (selector, element, targetWindow, videoBeacons, videoParenentElement, callback) {
            var VIDEO_VIEW_ID = MSANTracker.utils.getVideoViewId();
            var newBeacons = [];
            for (var i = 0; i < videoBeacons.length; i++) {
                var elementBeacon = videoBeacons[i];
                PlayUtils.toTrackUrlCounts = PlayUtils.toTrackUrlCounts + 1;
                if (elementBeacon.type != "videoView") {
                    var rlink = MSANTracker.utils.getQueryParam("rlink", elementBeacon.url);
                    var decoded = decodeURIComponent(rlink);
                    var replaceRlink = MSANTracker.utils.replaceQueryParam("vi", VIDEO_VIEW_ID, decoded);
                    var encoded = encodeURIComponent(replaceRlink);
                    elementBeacon.url = MSANTracker.utils.replaceQueryParam("rlink", encoded, elementBeacon.url);
                }
                newBeacons.push({
                    selector: selector,
                    element: element,
                    videoParenentElement: videoParenentElement,
                    videoBeacon: elementBeacon,
                    action: callback,
                    targetWindow: targetWindow,
                    percentInView: elementBeacon.percentage ? elementBeacon.percentage : 50
                });
            }
            PlayUtils.elementsToTrack.push({
                element: element,
                trackBeacons: newBeacons
            });
            if (PlayUtils.processing == null) {
                PlayUtils.processing = setInterval(PlayUtils.process, PlayUtils.interval);
            }
            element.onplay = function () {
                PlayUtils.refreshBeaconsWhenStart(element, targetWindow);
            };
            element.onseeking = function () {
                PlayUtils.refreshBeaconsWhenStart(element, targetWindow);
            };
            return this;
        };
        PlayUtils.untrackElement = function (element) {
            var untrackIndex = PlayUtils.getElementBeaconsIndex(PlayUtils.elementsToTrack, element);
            if (untrackIndex >= 0) {
                PlayUtils.elementsToTrack.splice(untrackIndex, 1);
            }
        };
        PlayUtils.getElementBeaconsIndex = function (events, element) {
            if (events && events.length > 0) {
                for (var i = 0; i < events.length; i++) {
                    if (events[i].element == element) {
                        return i;
                    }
                }
            }
            return -1;
        };
        PlayUtils.refreshBeaconsWhenStart = function (element, targetWindow) {
            if (element && element.currentTime == 0) {
                var VIDEO_VIEW_ID = MSANTracker.utils.getVideoViewId();
                var beaconsToTrackIndex = PlayUtils.getElementBeaconsIndex(PlayUtils.elementsToTrack, element);
                if (beaconsToTrackIndex >= 0) {
                    var beaconsToTrack = PlayUtils.elementsToTrack[beaconsToTrackIndex].trackBeacons;
                    var newBeacons = [];
                    for (var i = 0; i < beaconsToTrack.length; i++) {
                        var elementBeacon = beaconsToTrack[i];
                        var vBeacon = elementBeacon.videoBeacon;
                        if (vBeacon.type != "videoView") {
                            if (PlayUtils.trackedBeacons.indexOf(vBeacon.url) >= 0) {
                                PlayUtils.toTrackUrlCounts = PlayUtils.toTrackUrlCounts + 1;
                            }
                            var rlink = MSANTracker.utils.getQueryParam("rlink", vBeacon.url);
                            var decoded = decodeURIComponent(rlink);
                            var replaceRlink = MSANTracker.utils.replaceQueryParam("vi", VIDEO_VIEW_ID, decoded);
                            var encoded = encodeURIComponent(replaceRlink);
                            vBeacon.url = MSANTracker.utils.replaceQueryParam("rlink", encoded, vBeacon.url);
                        }
                        newBeacons.push({
                            selector: elementBeacon.selector,
                            element: elementBeacon.element,
                            videoParenentElement: elementBeacon.videoParenentElement,
                            videoBeacon: vBeacon,
                            action: elementBeacon.action,
                            targetWindow: targetWindow,
                            percentInView: elementBeacon.percentInView ? elementBeacon.percentInView : 50
                        });
                    }
                    PlayUtils.elementsToTrack[beaconsToTrackIndex].trackBeacons = newBeacons;
                }
                if (PlayUtils.processing == null) {
                    PlayUtils.processing = setInterval(PlayUtils.process, PlayUtils.interval);
                }
            }
        };
        PlayUtils.process = function () {
            try {
                if (PlayUtils.elementsToTrack && PlayUtils.elementsToTrack.length > 0) {
                    for (var index = 0; index < PlayUtils.elementsToTrack.length; index++) {
                        var trackEvents = PlayUtils.elementsToTrack[index].trackBeacons;
                        for (var i = 0; i < trackEvents.length; i++) {
                            var event_1 = trackEvents[i];
                            if (PlayUtils.trackedBeacons.indexOf(event_1.videoBeacon.url) < 0) {
                                PlayUtils.trackPlay(event_1);
                            }
                        }
                    }
                    if (PlayUtils.toTrackUrlCounts === PlayUtils.trackedBeacons.length) {
                        PlayUtils.stopProcessing();
                    }
                }
            }
            catch (e) {
                var eToTrack = PlayUtils.elementsToTrack;
                if (eToTrack && eToTrack.length > 0 && eToTrack[0].trackBeacons && eToTrack[0].trackBeacons[0].videoBeacon) {
                    var beacon = eToTrack[0].trackBeacons[0].videoBeacon;
                    MSANTracker.Telemetry.logEvent(beacon.guid, "mt_err", { msg: e.message, details: beacon });
                }
                else {
                    MSANTracker.Telemetry.logEvent("", "mt_err", { msg: e.message });
                }
            }
        };
        PlayUtils.trackPlay = function (elementToTrack) {
            var videoDom = elementToTrack.element;
            var duration = elementToTrack.videoBeacon.duration;
            var currentTime = videoDom.currentTime * 1000;
            var type = elementToTrack.videoBeacon.type;
            var inviewCheckData = {
                targetWindow: elementToTrack.targetWindow,
                element: elementToTrack.videoParenentElement ? elementToTrack.videoParenentElement : elementToTrack.element,
                percentInView: elementToTrack.percentInView
            };
            if (MSANTracker.AppearUtils.isElementInView(inviewCheckData) && PlayUtils.trackedBeacons.indexOf(elementToTrack.videoBeacon.url) < 0) {
                if (type == "videoView") {
                    if (this.checkPlayedTime(videoDom) >= duration) {
                        elementToTrack.action.call(undefined, elementToTrack.selector, elementToTrack.videoBeacon);
                        PlayUtils.trackedBeacons.push(elementToTrack.videoBeacon.url);
                    }
                }
                else {
                    if (((duration == 0 && currentTime > duration) || (duration > 0 && this.checkCurrentTime(currentTime, duration)))) {
                        elementToTrack.action.call(undefined, elementToTrack.selector, elementToTrack.videoBeacon);
                        PlayUtils.trackedBeacons.push(elementToTrack.videoBeacon.url);
                    }
                }
            }
        };
        PlayUtils.checkCurrentTime = function (currentTime, duration) {
            return currentTime >= duration - 50 && currentTime <= duration + 50;
        };
        PlayUtils.checkPlayedTime = function (videoDom) {
            var playedTime = 0;
            if (videoDom.played && videoDom.played.length > 0) {
                for (var i = 0; i < videoDom.played.length; i++) {
                    playedTime += videoDom.played.end(i) - videoDom.played.start(i);
                }
            }
            return playedTime * 1000;
        };
        PlayUtils.stopProcessing = function () {
            clearInterval(PlayUtils.processing);
            PlayUtils.processing = null;
        };
        PlayUtils.elementsToTrack = [];
        PlayUtils.trackedBeacons = [];
        PlayUtils.processing = null;
        PlayUtils.interval = 100;
        PlayUtils.toTrackUrlCounts = 0;
        return PlayUtils;
    }());
    MSANTracker.PlayUtils = PlayUtils;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var ViewBeacon = (function () {
        function ViewBeacon() {
            this.type = "view";
            this.url = "";
            this.guid = "";
            this.triggerType = "view";
            this.percentage = 50;
            this.duration = 1000;
        }
        return ViewBeacon;
    }());
    MSANTracker.ViewBeacon = ViewBeacon;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var VideoBeacon = (function () {
        function VideoBeacon() {
            this.type = "videoView";
            this.url = "";
            this.guid = "";
            this.triggerType = "play";
            this.percentage = 50;
            this.duration = 0;
        }
        return VideoBeacon;
    }());
    MSANTracker.VideoBeacon = VideoBeacon;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    var TrackableElement = (function () {
        function TrackableElement() {
            this.impid = "";
            this.rid = "";
            this.beacons = [];
        }
        return TrackableElement;
    }());
    MSANTracker.TrackableElement = TrackableElement;
})(MSANTracker || (MSANTracker = {}));
var MSANTracker;
(function (MSANTracker) {
    MSANTracker.config = null;
    MSANTracker.isInitialized = false;
    MSANTracker.scriptSrc = "";
    function Initialize() {
        MSANTracker.config = MSANTracker.Config.trackerConfig;
        MSANTracker.Telemetry.initialize(MSANTracker._window);
        if (MSANTracker.config.publisherName != "msnperegrine") {
            MSANTracker.Telemetry.logEvent("", "mt_info", { msg: "MSANTracker JS Inserted" });
        }
        var currentScriptSrc = MSANTracker.utils.getCurrentScriptTag(MSANTracker._window);
        if (currentScriptSrc) {
            MSANTracker.scriptSrc = currentScriptSrc;
        }
        else {
            if (MSANTracker.config.publisherName != "msnperegrine") {
                MSANTracker.Telemetry.logEvent("", "mt_err", { msg: "Cannot find current script src" });
            }
            return;
        }
        if (!MSANTracker.isInitialized && !MSANTracker.config.directFunctionCall) {
            var waitToInitialize = setInterval(function () {
                if (MSANTracker.utils.isDocumentReady(MSANTracker._window)) {
                    MSANTracker.isInitialized = true;
                    MSANTracker.Telemetry.logEvent("", "mt_info", { msg: "Document in ready state" });
                    clearInterval(waitToInitialize);
                    ProcessTrackers(MSANTracker._window);
                }
                else {
                    return;
                }
            }, 100);
        }
    }
    MSANTracker.Initialize = Initialize;
    function ProcessTrackers(targetWindow) {
        var element = new MSANTracker.TrackableElement();
        var params = new URLSearchParams(MSANTracker.scriptSrc);
        if (!params) {
            MSANTracker.Telemetry.logEvent("", "mt_err", { msg: "invalid script src url for params", url: MSANTracker.scriptSrc });
            return;
        }
        var beaconUrl = "";
        if (params.has("v")) {
            beaconUrl = params.get("v");
        }
        else {
            MSANTracker.Telemetry.logEvent("", "mt_err", { msg: "viewability beacon not present", url: MSANTracker.scriptSrc });
            return;
        }
        if (params.has("d")) {
            var d = params.get("d");
            MSANTracker.Telemetry.logEvent("", "mt_info", { msg: "Version", clientVersion: d });
        }
        var beaconDecoded = decodeURI(beaconUrl);
        var beaconParams = new URLSearchParams(beaconDecoded);
        var macroId = MSANTracker.config.impressionIdParamName;
        if (beaconParams.has(macroId)) {
            element.impid = beaconParams.get(macroId);
        }
        if (element.impid == "") {
            MSANTracker.Telemetry.logEvent("", "mt_err", { msg: "view_id is empty or null", url: beaconDecoded });
            return;
        }
        if (beaconParams.has("rId")) {
            element.rid = beaconParams.get("rId");
        }
        var beacon = new MSANTracker.ViewBeacon();
        beacon.url = beaconDecoded;
        element.beacons = [beacon];
        var elements = [element];
        TrackElementsAndFireBeacons(elements, targetWindow, false);
    }
    MSANTracker.ProcessTrackers = ProcessTrackers;
    function TrackElements(elementsToTrack, targetWindow, directFunctionCall) {
        if (directFunctionCall === void 0) { directFunctionCall = true; }
        MSANTracker.Telemetry.logEvent("", "mt_info", { msg: "MSANTracker function called", directCall: directFunctionCall });
        if (!elementsToTrack) {
            MSANTracker.Telemetry.logEvent("", "mt_err", { msg: "elements null or empty" });
        }
        if (!MSANTracker.isInitialized && directFunctionCall) {
            var waitToInitialize = setInterval(function () {
                if (MSANTracker.utils.isDocumentReady(targetWindow)) {
                    MSANTracker.isInitialized = true;
                    MSANTracker.Telemetry.logEvent("", "mt_info", { msg: "Document in ready state" });
                    clearInterval(waitToInitialize);
                    TrackElementsAndFireBeacons(elementsToTrack, targetWindow, directFunctionCall);
                }
            }, 100);
        }
        else if (directFunctionCall) {
            TrackElementsAndFireBeacons(elementsToTrack, targetWindow, directFunctionCall);
        }
    }
    MSANTracker.TrackElements = TrackElements;
    function TrackElementsAndFireBeacons(elements, targetWindow, directFunctionCall) {
        if (directFunctionCall === void 0) { directFunctionCall = true; }
        if (!elements && (elements && elements.length > 0)) {
            MSANTracker.Telemetry.logEvent("", "mt_err", { msg: "elements null or empty" });
            return;
        }
        elements.forEach(function (trackerElement) {
            var guid = MSANTracker.utils.getGuid();
            if (!trackerElement.rid) {
                trackerElement.rid = MSANTracker.utils.getRid(trackerElement);
            }
            MSANTracker.Telemetry.setElementToTrack(guid, trackerElement.rid);
            if (!trackerElement.beacons || !trackerElement.impid) {
                MSANTracker.Telemetry.logEvent(guid, "mt_err", { msg: "Beacon or imp id is empty or null" });
                return;
            }
            var elementId = trackerElement.impid;
            if (MSANTracker.config.publisherName == "msn") {
                elementId = "bing-" + trackerElement.impid;
            }
            var getElementFromDom = true;
            if (trackerElement.element) {
                getElementFromDom = false;
            }
            var selector = MSANTracker.config.selectorMethod + "" + elementId;
            if (getElementFromDom) {
                var divElement = targetWindow.document.querySelector(selector);
                if (divElement) {
                    trackerElement.element = divElement;
                }
            }
            if (!trackerElement.element) {
                MSANTracker.Telemetry.logEvent(guid, "mt_err", { msg: "No element with id or element, setting an interval to wait", id: elementId, selector: selector });
                var waitToFindElement = setInterval(function () {
                    var divElement = targetWindow.document.querySelector(selector);
                    if (divElement) {
                        MSANTracker.Telemetry.logEvent(guid, "mt_info", { msg: "Found element after retry", element: selector });
                        clearInterval(waitToFindElement);
                        trackerElement.element = divElement;
                        ProcessElement(trackerElement, selector, targetWindow, elementId, guid);
                    }
                }, 100);
            }
            else {
                ProcessElement(trackerElement, selector, targetWindow, elementId, guid);
            }
        });
    }
    function ProcessElement(trackerElement, selector, targetWindow, elementId, guid) {
        var beacons = trackerElement.beacons;
        var videoBeacons = [];
        if (beacons && beacons.length > 0) {
            beacons.forEach(function (beacon) {
                MSANTracker.Telemetry.logEvent(guid, "mt_info", { msg: "Beacon Information", id: elementId, beaconUrl: beacon.url });
                beacon.guid = guid;
                if (beacon.triggerType == "play") {
                    videoBeacons.push(beacon);
                }
                else {
                    ProcessBeacon(beacon, trackerElement, selector, targetWindow);
                }
            });
        }
        if (videoBeacons && videoBeacons.length > 0) {
            ProcessVideoBeacon(videoBeacons, trackerElement, selector, targetWindow);
        }
    }
    function ProcessVideoBeacon(beacons, trackElement, selector, targetWindow) {
        var videoBeacons = beacons;
        MSANTracker.PlayUtils.trackElement(selector, trackElement.element, targetWindow, videoBeacons, trackElement.videoParenentElement, function (selector, beacon) {
            var id = selector.split(MSANTracker.config.selectorMethod)[1];
            MSANTracker.Telemetry.logVideoAdPlay(beacon.guid, id, beacon);
            MSANTracker.utils.fireBeacon(beacon.url);
            console.log("[MSAN video beacon fired] " + beacon.url);
        });
    }
    function ProcessBeacon(beacon, trackElement, selector, targetWindow) {
        var _this = this;
        if (!beacon.triggerType || beacon.triggerType === "view") {
            var viewBeacon = beacon;
            MSANTracker.AppearUtils.trackElement(selector, trackElement.element, targetWindow, viewBeacon, function (selector, beacon, rid) {
                var id = selector.split(MSANTracker.config.selectorMethod)[1];
                MSANTracker.Telemetry.logAdView(beacon.guid, id, beacon);
                MSANTracker.utils.fireBeacon(beacon.url);
                console.log("[MSAN view beacon fired] " + beacon.url);
            });
        }
        else if (beacon.type === "click") {
            var beaconElement = trackElement.element;
            beaconElement.addEventListener("click", function (ev) {
                MSANTracker.Telemetry.logAdClick(beacon.guid, _this.id, beacon);
                MSANTracker.utils.fireBeacon(beacon.url);
            });
        }
        else {
            MSANTracker.Telemetry.logEvent(beacon.guid, "mt_err", { msg: "Unsupported tracker event", impid: trackElement.impid });
        }
    }
})(MSANTracker || (MSANTracker = {}));
if (MSANTracker._window) {
    MSANTracker.Initialize();
    MSANTracker._window.MSANTracker = MSANTracker;
}
